export enum AgentFiltersEnum {
  selectFilter = '',
  status = 'status',
  name = 'name',
  source = 'source',
  externalId = 'externalId',
  email = 'email',
}
